import React, { Component } from 'react'
import SearchResults from './searchResults.js'
import { buildSearchTitle } from '../searchUtil'
import {
  brandDefault,
  BRAND_FILTER_SHORT_NAME,
} from '../../filters/brand/searchBrandConfig'
import {
  priceDefault,
  PRICE_FILTER_SHORT_NAME,
} from '../../filters/price/priceFilterConfig'
import {
  bookingFilterDefault,
  INSTANT_BOOKING_SHORT_NAME,
} from '../../filters/instantBooking/instantBookingConfig'
import {
  styleDefault,
  STYLE_FILTER_SHORT_NAME,
} from '../../filters/style/styleFilterConfig'

import {
  MAX_DISTANCE_FILTER_SHORT_NAME,
  MIN_DISTANCE_FILTER_SHORT_NAME,
  DISTANCE_INCREMENT_VALUE,
  maxDistanceDefault,
  minDistanceDefault,
} from '../../filters/moreFiltersContainer/distanceFilterConfig'
import {
  YEAR_FILTER_SHORT_NAME,
  yearDefault,
} from '../../filters/moreFiltersContainer/yearsFilterConfig'
import { LOCATION_SHORT_NAME } from '../../filters/location/locationFiltersConfig'
import {
  PAGE_FILTER_SHORT_NAME,
  pageDefault,
} from '../../filters/pagination/paginationFilterConfig'
import {
  START_DATE_SHORT_NAME,
  END_DATE_SHORT_NAME,
  startDateDefault,
  endDateDefault,
} from '../../filters/dates/datesFilterConfig'
import {
  IS_BIKE_FOR_SALE_FILTER_SHORT_NAME,
  isBikeForSaleDefault,
} from '../../filters/moreFiltersContainer/isBikeForSaleFilterConfig'

import { defaultMapOptions } from '../map/defaultMapOptions'
import SearchMapBox from '../../layout/map/searchMapBox'
import {
  buildTheQueryString,
  removeDefaults,
} from '../../filters/filterUtil.js'
import SearchSkeleton from '../../skeleton/MainSearchSkeleton'
import SearchGooseEgg from '../gooseneck/searchGooseEgg'
import { withRouter, Link } from 'react-router-dom'
import { Columns, Header } from 'components/elements/index.js'
import Skeleton from 'react-loading-skeleton'
import DotsLoaderDark from '../../../../components/theme/assets/images/loaders/three-dots-dark.svg'
import './mapboxOverlay.css'

let classNames = require('classnames')

const calcMinHeight = (offset) => {
  return window.innerHeight - offset
}

const mapTop = (offset) => {
  return {
    paddingTop: offset,
    marginTop: -offset,
  }
}

const MapBoxWrapper = (props) => {
  const { isLoading, ...rest } = props;
  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <SearchMapBox {...rest} isLoading={props.isLoading}/>

      {/* Loading overlay */}
      {isLoading && (
        <div className='mapbox-overlay'>
          <img src={DotsLoaderDark} alt="Loading..." />
        </div>
      )}
    </div>
  );
}

class SearchResultsLayoutWrap extends Component {
  constructor(props) {
    super(props)
    this.state = {
      overRideMapVisibility: false,
      focusedResult: null,
      gooseEggResults: [],
      gooseEggMeta: {},
      callingLoadMore: false,
    }
  }



  updateSearchResults = (searchData, searchMeta) => {
    this.setState({
      gooseEggResults: searchData,
      gooseEggMeta: searchMeta,
      //hasGooseEgg
    })
  }


  setFocused = (focusedResult) => {
    this.setState({ focusedResult })
  }

  isLoading = () => {
    return this.props.searchLoading
  }

  hasResults = () => {
    if (
      this.props.hasSearchData &&
      this.props.searchData.length > 0
    ) {
      return true
    } else {
      return false
    }
  }

  hasGooseEgg = () => {
    if (
      !this.props.searchLoading &&
      !this.props.hasSearchData &&
      this.props.searchData.length === 0 &&
      !this.props.searchError
    ) {
      return true
    } else {
      return false
    }
  }

  hasInitialLoadError = () => {
    if (
      !this.props.searchLoading &&
      this.props.searchError &&
      !this.props.hasSearchData
    ) {
      return true
    } else {
      return false
    }
  }

  hasErrorAfterLoad = () => {
    if (
      !this.props.searchLoading &&
      this.props.searchError &&
      this.props.hasSearchData
    ) {
      return true
    } else {
      return false
    }
  }

  clearAllFilters = () => {
    let filterValues = this.props.filterValues
    filterValues[STYLE_FILTER_SHORT_NAME] = styleDefault
    filterValues[PRICE_FILTER_SHORT_NAME] = priceDefault
    filterValues[INSTANT_BOOKING_SHORT_NAME] = bookingFilterDefault
    filterValues[BRAND_FILTER_SHORT_NAME] = brandDefault
    filterValues[MIN_DISTANCE_FILTER_SHORT_NAME] = minDistanceDefault
    filterValues[MAX_DISTANCE_FILTER_SHORT_NAME] = maxDistanceDefault
    filterValues[YEAR_FILTER_SHORT_NAME] = yearDefault
    filterValues[START_DATE_SHORT_NAME] = startDateDefault
    filterValues[END_DATE_SHORT_NAME] = endDateDefault
    filterValues[IS_BIKE_FOR_SALE_FILTER_SHORT_NAME] = isBikeForSaleDefault
    filterValues[PAGE_FILTER_SHORT_NAME] = pageDefault
    let newQueryString = buildTheQueryString(removeDefaults(filterValues))
    this.props.history.push('?' + newQueryString)
    this.props.runSearch(filterValues, 'clear all filters')
  }

  getNextSearchUrl = () => {
    let filterValues = { ...this.props.filterValues }
    if (filterValues['page']) {
      delete filterValues['page']
    }
    filterValues[MIN_DISTANCE_FILTER_SHORT_NAME] = minDistanceDefault
    filterValues[MAX_DISTANCE_FILTER_SHORT_NAME] =
      (filterValues[MAX_DISTANCE_FILTER_SHORT_NAME] || maxDistanceDefault) +
      DISTANCE_INCREMENT_VALUE
    let newQueryString = buildTheQueryString(removeDefaults(filterValues))
    return `/search?${newQueryString}`
  }

  render() {
    const { focusedResult, gooseEggResults } = this.state
    const {
      isMobile,
      searchMeta,
      searchData,
      mapVisible,
      searchLoading,
      //searchData,
      //searchMeta,
      startDate,
      endDate,
      filterValues,
      offset,
      mapboxSearchError,
      mapboxSearchLoading,
      hasMapboxSearchData,
      groupedMarkers,
      allCoordinates,
      onScroll,
      advertisement,
      allAdvertisements,
      userCreditsCents,
      userFreeDays,
      userIsRpmComotoMember,
      ridesUntilFreeDay
    } = this.props
    const { page, total_pages } = this.props.searchMeta || {}

    let searchResultsClassWrap = classNames(
      'search-left',
      this.props.className,
      {
        'desktop-results-map': !isMobile && mapVisible,
        'desktop-results-no-map': !isMobile && !mapVisible,
        'mobile-results': isMobile,
        //'hide-map-override' :  this.hasGooseEgg() || this.hasInitialLoadError(),
      }
    )

    return (
      <div
        id="scrollableDiv"
        className="search-wrap"
        style={{
          paddingTop: '0px',
        }}
      >
        <div className={searchResultsClassWrap}>
          <div
            className="search-left-inner"
            style={{ minHeight: calcMinHeight(offset) }}
          >
            {this.hasErrorAfterLoad() && (
              <div className="message is-danger">
                <div className="message-body">
                  <p>
                    Sorry, we are having trouble loading the results right now.
                    Please try again.
                  </p>
                </div>
              </div>
            )}
            {this.hasResults() && ( //if we have good results
              <React.Fragment>
                <Columns>
                  <Columns.Column>
                    <Header
                      size={4}
                      className="has-text-weight-bold search-city"
                    >
                      <span className="has-text-primary has-text-weight-extra-bold total-search">
                        {searchMeta.total_results}
                      </span>{' '}
                      {buildSearchTitle(
                        searchMeta.total_results,
                        filterValues[LOCATION_SHORT_NAME],
                        false
                      )}
                      {page === total_pages && (
                        <div className="is-size-6 py-2">
                          Didn’t find what you were looking for? <br />
                          <Link
                            className="try-searching-farther-away"
                            to={this.getNextSearchUrl()}
                          >
                            Try searching farther away
                          </Link>
                        </div>
                      )}
                    </Header>
                  </Columns.Column>
                </Columns>
                <SearchResults
                  //to avoid price display issue when filters applied
                  // <pageNumber + randomNumber>
                  key={page + (Math.random() * 1000)}
                  isMobile={isMobile}
                  mapVisible={mapVisible}
                  searchResults={searchData}
                  startDate={startDate}
                  endDate={endDate}
                  focusedResult={focusedResult}
                  onResultHover={this.setFocused}
                  isSearchPage={true}
                  loadMore={onScroll}
                  searchMeta={searchMeta}
                  advertisement={advertisement}
                  allAdvertisements={allAdvertisements}
                  searchLoading={searchLoading}
                  currentTotalResults ={searchData.length}
                  userCreditsCents={userCreditsCents}
                  userFreeDays={userFreeDays}
                  userIsRpmComotoMember={userIsRpmComotoMember}
                  ridesUntilFreeDay={ridesUntilFreeDay}
                />
              </React.Fragment>
            )}
            {searchLoading && searchData.length <= 0 && ( //if it's loading
              <SearchSkeleton isMobile={isMobile} isVisible={mapVisible} showHeader={true}/>)
            }
            {this.hasGooseEgg() && (
              //eventually we'll move goose egg up above the SearchResults Component.
              //And then just display the header portion where needed.
              <SearchGooseEgg
                //reloadPage={runSearch}
                filterValues={filterValues}
                isMobile={isMobile}
                mapVisible={mapVisible}
                onUpdateResults={this.updateSearchResults}
                onClearFilters={this.clearAllFilters}
                nextSearchUrl={this.getNextSearchUrl()}
              />
            )}
            {this.hasInitialLoadError() && (
              <SearchGooseEgg
                //reloadPage={runSearch}
                filterValues={filterValues}
                mapVisible={mapVisible}
                onUpdateResults={this.updateSearchResults}
                onClearFilters={this.clearAllFilters}
                isMobile={isMobile}
                nextSearchUrl={this.getNextSearchUrl()}
              />
            )}
          </div>
        </div>
        {!hasMapboxSearchData && mapVisible && (
          <div
            className="search-right-container"
            style={{ minHeight: calcMinHeight(offset) }}
          >
            <div
              className="search-right"
              id="search-right-map"
              style={mapTop(offset)}
            >
              <Skeleton height="100%" />
            </div>
          </div>
        )}
        {hasMapboxSearchData && mapVisible && (
          <div
            className="search-right-container"
            style={{ minHeight: calcMinHeight(offset) }}
          >
            <div
              className="search-right"
              id="search-right-map"
              style={mapTop(offset)}
            >
              <div id="twisted-map-w-markers">
                <MapBoxWrapper
                  searchResults={searchData}
                  center={{
                    lat: Number(filterValues.latitude),
                    lng: Number(filterValues.longitude),
                  }}
                  isMobile={isMobile}
                  focusedResult={focusedResult}
                  onResultHover={this.setFocused}
                  startDate={startDate}
                  endDate={endDate}
                  runSearch={this.props.runSearch}
                  hasMapboxSearchData={hasMapboxSearchData}
                  groupedMarkers={groupedMarkers}
                  allCoordinates={allCoordinates}
                  onMapMove={this.props.onMapMove}
                  isLoading={mapboxSearchLoading}
                />
              </div>
            </div>
          </div>
        )}
        {this.hasGooseEgg() && mapVisible && (
          <div
            className="search-right-container"
            style={{ minHeight: calcMinHeight(offset) }}
          >
            <div
              className="search-right map-goose-egg"
              id="search-right-map"
              style={mapTop(offset)}
            >
              <MapBoxWrapper
                options={defaultMapOptions}
                searchResults={searchData}
                center={{
                  lat: Number(filterValues.latitude),
                  lng: Number(filterValues.longitude),
                }}
                hasSearchResults={searchData.length > 0 ? true : false}
                isMobile={isMobile}
                focusedResult={focusedResult}
                onResultHover={this.setFocused}
                startDate={startDate}
                endDate={endDate}
                runSearch={this.props.runSearch}
                hasMapboxSearchData={hasMapboxSearchData}
                onMapMove={this.props.onMapMove}
                groupedMarkers={groupedMarkers}
                allCoordinates={allCoordinates}
                isLoading={mapboxSearchLoading}
                hasGooseEgg={true}
              />
            </div>
          </div>
        )}
        {this.props.children}
      </div>
    )
  }
}

export default withRouter(SearchResultsLayoutWrap)

SearchResultsLayoutWrap.defaultProps = {
  dimmerOn: false,
  isMobile: false,
  mapVisible: true,
  filterValues: {
    location: null,
  },
  searchLoading: false,
  onMapUpdate: function () { },
  runSearch: function () { },
  onPagination: function () { },
  searchError: false,
  hasSearchData: false,
  searchData: [],
  searchMeta: {},
  startDate: null,
  endDate: null,
  offset: 0,
}
